import React from "react";
import ProjectList from "../../../../components/support/Project";


function Index(props) {

    return (<ProjectList isTenant={true}/>)
}

export default Index